import { ACCOUNT_ROLES } from 'src/constants/globalConstants';

export const accountTypeFields = [
  { key: ACCOUNT_ROLES.USER, label: 'User' },
  { key: ACCOUNT_ROLES.COMPANY, label: 'Company' }
];
